// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"mx-z","smallCardRow":"nx-z","largeCardRow":"ox-z","productSearchRow":"px-z","curatedRow":"qx-z"};